// src/pages/home/Home.js
import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Spinner from 'react-bootstrap/Spinner'
import { useHistory } from 'react-router-dom'

import api from 'api/api'
import './home.css'

function Home() {
	const [loading, setLoading] = useState(true)
	const [stats, setStats] = useState(null)
	const history = useHistory()

	useEffect(() => {
		cargarEstadisticas()
	}, [])

	const cargarEstadisticas = async () => {
		try {
			setLoading(true)
			const { datos, error } = await api.get('a/solicitudes-estadisticas')

			if (!error && datos) {
				setStats(datos)
			}
		} catch (error) {
			console.error('Error al cargar estadisticas:', error)
		} finally {
			setLoading(false)
		}
	}

	const navegarA = (ruta) => {
		history.push(ruta)
	}

	if (loading) {
		return (
			<Container fluid id="home" className="vh-100">
				<Row className="d-flex no-gutters">
					<Col xs={12} className="mt-2">
						<h1>Inicio</h1>
						<hr />
					</Col>
				</Row>
				<Row className="justify-content-center mt-5">
					<Spinner animation="border" variant="primary" />
				</Row>
			</Container>
		)
	}

	return (
		<Container fluid id="home" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Inicio</h1>
					<hr />
				</Col>
			</Row>

			{/* Tarjetas principales */}
			<Row className="mb-4">
				<Col xs={12} sm={6} lg={3} className="mb-3">
					<Card
						className="stat-card stat-card-primary h-100"
						onClick={() => navegarA('/solicitudes/activas')}
					>
						<Card.Body>
							<div className="d-flex justify-content-between align-items-center">
								<div>
									<h6 className="text-muted mb-1">Solicitudes Activas</h6>
									<h2 className="mb-0">{stats?.activas || 0}</h2>
								</div>
								<div className="stat-icon">
									<i className="fa-solid fa-clipboard-list"></i>
								</div>
							</div>
						</Card.Body>
						<Card.Footer className="bg-transparent border-0">
							<small className="text-muted">
								<i className="fa fa-arrow-right me-1"></i> Ver solicitudes activas
							</small>
						</Card.Footer>
					</Card>
				</Col>

				<Col xs={12} sm={6} lg={3} className="mb-3">
					<Card
						className="stat-card stat-card-success h-100"
						onClick={() => navegarA('/solicitudes/agendadas')}
					>
						<Card.Body>
							<div className="d-flex justify-content-between align-items-center">
								<div>
									<h6 className="text-muted mb-1">Solicitudes Agendadas</h6>
									<h2 className="mb-0">{stats?.agendadas || 0}</h2>
								</div>
								<div className="stat-icon stat-icon-success">
									<i className="fa-solid fa-calendar-check"></i>
								</div>
							</div>
						</Card.Body>
						<Card.Footer className="bg-transparent border-0">
							<small className="text-muted">
								<i className="fa fa-arrow-right me-1"></i> Ver agendadas
							</small>
						</Card.Footer>
					</Card>
				</Col>

				<Col xs={12} sm={6} lg={3} className="mb-3">
					<Card className="stat-card stat-card-info h-100">
						<Card.Body>
							<div className="d-flex justify-content-between align-items-center">
								<div>
									<h6 className="text-muted mb-1">Solicitudes Hoy</h6>
									<h2 className="mb-0">{stats?.hoy || 0}</h2>
								</div>
								<div className="stat-icon stat-icon-info">
									<i className="fa-solid fa-clock"></i>
								</div>
							</div>
						</Card.Body>
						<Card.Footer className="bg-transparent border-0">
							<small className="text-muted">
								Creadas en el dia de hoy
							</small>
						</Card.Footer>
					</Card>
				</Col>

				<Col xs={12} sm={6} lg={3} className="mb-3">
					<Card className="stat-card stat-card-warning h-100">
						<Card.Body>
							<div className="d-flex justify-content-between align-items-center">
								<div>
									<h6 className="text-muted mb-1">Esta Semana</h6>
									<h2 className="mb-0">{stats?.estaSemana || 0}</h2>
								</div>
								<div className="stat-icon stat-icon-warning">
									<i className="fa-solid fa-chart-line"></i>
								</div>
							</div>
						</Card.Body>
						<Card.Footer className="bg-transparent border-0">
							<small className="text-muted">
								Solicitudes de esta semana
							</small>
						</Card.Footer>
					</Card>
				</Col>
			</Row>

			{/* Detalle por estados */}
			<Row>
				<Col xs={12} lg={6} className="mb-4">
					<Card>
						<Card.Header>
							<h5 className="mb-0">
								<i className="fa-solid fa-chart-pie me-2"></i>
								Solicitudes por Estado
							</h5>
						</Card.Header>
						<Card.Body>
							{stats?.porEstado && (
								<div className="estado-list">
									{/* Activas */}
									<div className="estado-group mb-3">
										<h6 className="text-muted mb-2">Activas</h6>
										<div className="d-flex flex-wrap gap-2">
											<EstadoBadge
												estado="Pendientes"
												cantidad={stats.porEstado.pendiente || 0}
												variant="secondary"
											/>
											<EstadoBadge
												estado="Confirmando pago"
												cantidad={stats.porEstado.confirmando_pago || 0}
												variant="info"
											/>
											<EstadoBadge
												estado="Pagadas"
												cantidad={stats.porEstado.pagado || 0}
												variant="primary"
											/>
											<EstadoBadge
												estado="Aceptadas"
												cantidad={stats.porEstado.aceptado || 0}
												variant="success"
											/>
										</div>
									</div>

									{/* Agendadas */}
									<div className="estado-group mb-3">
										<h6 className="text-muted mb-2">En Proceso</h6>
										<div className="d-flex flex-wrap gap-2">
											<EstadoBadge
												estado="Agendadas"
												cantidad={stats.porEstado.agendado || 0}
												variant="success"
											/>
										</div>
									</div>

									{/* Historial */}
									<div className="estado-group">
										<h6 className="text-muted mb-2">Finalizadas</h6>
										<div className="d-flex flex-wrap gap-2">
											<EstadoBadge
												estado="Completadas"
												cantidad={stats.porEstado.completado || 0}
												variant="success"
											/>
											<EstadoBadge
												estado="Canceladas"
												cantidad={stats.porEstado.cancelado || 0}
												variant="danger"
											/>
											<EstadoBadge
												estado="Abandonadas"
												cantidad={stats.porEstado.abandonado || 0}
												variant="secondary"
											/>
										</div>
									</div>
								</div>
							)}
						</Card.Body>
					</Card>
				</Col>

				<Col xs={12} lg={6} className="mb-4">
					<Card>
						<Card.Header>
							<h5 className="mb-0">
								<i className="fa-solid fa-bolt me-2"></i>
								Accesos Rapidos
							</h5>
						</Card.Header>
						<Card.Body>
							<Row>
								<Col xs={6} className="mb-3">
									<Card
										className="acceso-rapido"
										onClick={() => navegarA('/profesionales/pendientes')}
									>
										<Card.Body className="text-center py-4">
											<i className="fa-solid fa-user-clock fa-2x mb-2 text-warning"></i>
											<p className="mb-0">Profesionales Pendientes</p>
										</Card.Body>
									</Card>
								</Col>
								<Col xs={6} className="mb-3">
									<Card
										className="acceso-rapido"
										onClick={() => navegarA('/profesionales/activos')}
									>
										<Card.Body className="text-center py-4">
											<i className="fa-solid fa-user-check fa-2x mb-2 text-success"></i>
											<p className="mb-0">Profesionales Activos</p>
										</Card.Body>
									</Card>
								</Col>
								<Col xs={6} className="mb-3">
									<Card
										className="acceso-rapido"
										onClick={() => navegarA('/usuarios')}
									>
										<Card.Body className="text-center py-4">
											<i className="fa-solid fa-users fa-2x mb-2 text-primary"></i>
											<p className="mb-0">Usuarios</p>
										</Card.Body>
									</Card>
								</Col>
								<Col xs={6} className="mb-3">
									<Card
										className="acceso-rapido"
										onClick={() => navegarA('/solicitudes/historial')}
									>
										<Card.Body className="text-center py-4">
											<i className="fa-solid fa-history fa-2x mb-2 text-secondary"></i>
											<p className="mb-0">Historial</p>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

// Componente auxiliar para mostrar badges de estado
function EstadoBadge({ estado, cantidad, variant }) {
	const bgColors = {
		primary: '#0d6efd',
		secondary: '#6c757d',
		success: '#198754',
		danger: '#dc3545',
		warning: '#ffc107',
		info: '#0dcaf0'
	}

	return (
		<div
			className="estado-badge"
			style={{
				backgroundColor: bgColors[variant] || bgColors.secondary,
				color: variant === 'warning' ? '#000' : '#fff'
			}}
		>
			<span className="estado-nombre">{estado}</span>
			<span className="estado-cantidad">{cantidad}</span>
		</div>
	)
}

export default Home